"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexInputField = void 0;
const react_1 = __importStar(require("react"));
const ColorPicker_module_css_1 = __importDefault(require("../public/ColorPicker.module.css"));
const HexInputField = (props) => {
    const { color } = props;
    const [isHexInputFocused, setHexInputFocused] = (0, react_1.useState)(false);
    const [hexInputValue, setHexInputValue] = (0, react_1.useState)("FF0000");
    const hexChange = (event) => {
        let value = event.target.value;
        if (value.length > 6) {
            value = value.substring(0, 6);
        }
        setHexInputValue(value); // Updates the value in the input field.
        if (value.length < 6) {
            value = value.padEnd(6, "0"); // Auto fills the hex value used to update the selectors position.
        }
        if (!/^[0-9A-F]{6}$/i.test(value)) {
            return;
        }
        color.setHex("#" + value);
        color.updateRGBFromHex();
        color.updateHSVFromRGB();
        color.updateColorSelectors();
        color.handleCallback();
    };
    const focusHandler = (event) => {
        setHexInputFocused(true);
        setHexInputValue(color.getHex().split("#")[1]);
        setTimeout(() => event.target.select(), 0);
    };
    const blurHandler = () => {
        setHexInputFocused(false);
        setHexInputValue(color.getHex());
    };
    const copyHandler = (event) => {
        event.preventDefault();
        const hexaData = color.getHexa();
        event.clipboardData.setData("text/plain", hexaData);
    };
    const pasteHandler = (event) => {
        let pasteData = event.clipboardData.getData("text/plain");
        if (pasteData.substring(0, 1) === "#") {
            pasteData = pasteData.slice(1);
        }
        if (!/^[0-9A-F]{6}$|^[0-9A-F]{8}$/i.test(pasteData)) {
            // If the pasted data isn't hex or hexa then return
            return;
        }
        let hex = pasteData.slice(0, 6);
        let alpha = 1;
        if (pasteData.length == 8) {
            const alphaHexCode = pasteData.slice(6, 8);
            alpha = parseInt(alphaHexCode, 16) / 255;
        }
        setHexInputValue(hex);
        color.setHex("#" + hex);
        color.setAlpha(alpha);
        color.updateRGBFromHex();
        color.updateHSVFromRGB();
        color.updateColorSelectors();
        color.updateAlphaSelector();
        color.handleCallback();
    };
    const clickHandler = () => {
        var _a;
        if (color.hexInputRef) {
            (_a = color.hexInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    return (react_1.default.createElement("div", { className: `${ColorPicker_module_css_1.default.color_input_fields} text-center`, onClick: clickHandler },
        react_1.default.createElement("span", { onClick: clickHandler }, "#"),
        react_1.default.createElement("input", { ref: color.hexInputRef, value: isHexInputFocused ? hexInputValue : color.getHex().split("#")[1], onBlur: blurHandler, onCopy: copyHandler, onPaste: pasteHandler, onFocus: focusHandler, onChange: hexChange, className: ColorPicker_module_css_1.default.hex_input_field, "data-cy": "ColorPickerHexInput" })));
};
exports.HexInputField = HexInputField;
